<template>
  <div class="component-button">
   <div class="panel-basic" ref="panelBasic">
     <el-collapse accordion>
       <order-panel @updateOrder="updateOrder" :orders="orders"></order-panel>
       <group-panel @updateGroup="updateGroup" @updateGroupByEnable="updateGroupByEnable" :groupBies="groupBies"></group-panel>
       <filter-senior-panel @updateSeniorFilter="updateSeniorFilter"  @updateGroupFilterExpressionStr="updateGroupFilterExpressionStr"></filter-senior-panel>
       <common-panel
         @updateSecurityEnable="updateSecurityEnable"
         @updateAdvancedFilter="updateAdvancedFilter"
         @updateConditionsRequired="updateConditionsRequired"
         @updateAppModelOff="updateAppModelOff"
         @updataAppModel="updataAppModel"
         @updateBatchHandle="updateBatchHandle"
         @updatePageNumber="updatePageNumber"
         @updateOperationPosition="updateOperationPosition"
         @updateOpenStartLoadData="updateOpenStartLoadData"
         @updateBgColor="updateBgColor"
         @updateGroupReportData="updateGroupReportData"
         @updateMergeSame="updateMergeSame"
         @updateColumnEdit="updateColumnEdit"
         @updateEditColumns="updateEditColumns"
         @updateEditColumnForm="updateEditColumnForm"
         ></common-panel>
     </el-collapse>
   </div>

    <div class="panel-basic-btns">
      <el-button type="primary" @click="saveAttr">保存</el-button>
      <el-button @click="closeAttr">取消</el-button>
    </div>
  </div>
</template>
<script>
import OrderPanel from './order-panel.vue'
import GroupPanel from './group-panel.vue'
import FilterSeniorPanel from './filter-senior-panel'
import CommonPanel from './common-panel.vue'
import Order from '@/store/report/order.js'
import Group from '@/store/report/group.js'
export default {
  name: 'basic-panel',
  inject: ['reportService', 'reportComment'],
  components: {
    OrderPanel,
    GroupPanel,
    CommonPanel,
    FilterSeniorPanel
  },
  data () {
    let orders = this.$_.cloneDeep(this.reportService.report.orderBies)
    let groupBies = this.$_.cloneDeep(this.reportService.report.groupBies)
    let systemFilterSwitch = this.$_.cloneDeep(this.reportService.report.systemFilterSwitch)
    let groupByEnable = false
    if (!orders.length) {
      let order = new Order({ columnId: '', orderType: 'asc' })
      orders.push(order)
    }
    if (!groupBies.length) {
      let group = new Group({ columnId: '' })
      groupBies.push(group)
    } else {
      groupByEnable = this.reportService.report.groupByEnable
    }
    let securityEnable = this.reportService.report.securityEnable
    let advancedFilter = this.reportService.report.advancedFilter
    let conditionsRequired = this.reportService.report.conditionsRequired
    let appSwitch = this.reportService.report.appSwitch
    let appModel = this.reportService.report.appModel
    return {
      orders,
      groupBies,
      groupByEnable: groupByEnable,
      securityEnable: securityEnable,
      advancedFilter: advancedFilter,
      conditionsRequired: conditionsRequired,
      appSwitch,
      appModel,
      seniorFilter: { expression: this.reportService.report.filterExpression },
      systemFilterSwitch,
      batchHandle: this.reportService.report.batchHandle,
      pageNumber: this.reportService.report.pageNumber,
      groupReportData: this.reportService.report.groupReportData,
      isGroupReportSign: this.reportService.report.isGroupReportSign,
      operationPosition: this.reportService.report.operationPosition,
      openStartLoadData: this.reportService.report.openStartLoadData,
      bgColor: this.reportService.report.bgColor,
      mergeSame: this.reportService.report.mergeSame,
      columnEdit: this.reportService.report.columnEdit,
      editColumns: this.reportService.report.editColumns,
      editColumnForm: this.reportService.report.editColumnForm,
      groupFilterExpressionStr: this.reportService.report.groupFilterExpressionStr
    }
  },
  methods: {
    updateOrder (orders) {
      this.orders = orders
    },
    updateGroup (groupBies) {
      this.groupBies = groupBies
    },
    updateGroupByEnable (groupByEnable) {
      this.groupByEnable = groupByEnable
    },
    updateSecurityEnable (securityEnable) {
      this.securityEnable = securityEnable
    },
    updateAdvancedFilter (advancedFilter) {
      this.advancedFilter = advancedFilter
    },
    updateConditionsRequired (conditionsRequired) {
      this.conditionsRequired = conditionsRequired
    },
    updateAppModelOff (off) {
      this.appSwitch = off
    },
    updataAppModel (appModel) {
      this.appModel = appModel
    },
    updateSeniorFilter (seniorFilter) {
      this.seniorFilter = seniorFilter
      this.systemFilterSwitch = seniorFilter.systemFilterSwitch
    },
    updateBatchHandle (batchHandle) {
      this.batchHandle = batchHandle
    },
    updatePageNumber (number) {
      this.pageNumber = number
    },
    updateOperationPosition (position) {
      this.operationPosition = position
    },
    updateGroupReportData (groupReportData) {
      this.groupReportData = groupReportData
    },
    updateOpenStartLoadData (state) {
      this.openStartLoadData = state
    },
    updateBgColor (state) {
      this.bgColor = state
    },
    updateMergeSame (mergeSame) {
      this.mergeSame = mergeSame
    },
    updateColumnEdit (state) {
      this.columnEdit = state
      state && this.scrollDown()
    },
    updateEditColumns (arr) {
      this.editColumns = arr
    },
    updateEditColumnForm (id) {
      this.editColumnForm = id
      this.scrollDown()
    },
    updateGroupFilterExpressionStr (groupFilterExpressionStr) {
      this.groupFilterExpressionStr = groupFilterExpressionStr
    },
    saveAttr () {
    // 分组如果关闭了需要将全部的非senior的filter的filtertype变成ordinary
      if (this.groupByEnable === false) {
        this.groupFilterExpressionStr = ''
        this.reportService.report.filters.filter(m => m.filterType !== 'senior').forEach(m => {
          m.filterType = 'ordinary'
        })
      }
      let groupBies = this.groupBies.filter(m => m.columnId)
      let orderBies = this.orders.filter(m => m.columnId)
      let groupByEnable = this.groupByEnable
      let securityEnable = this.securityEnable
      let advancedFilter = this.advancedFilter
      let conditionsRequired = this.conditionsRequired
      let expression = this.seniorFilter.expression
      let groupReportData = this.groupReportData
      if (this.groupByEnable && Object.keys(groupBies).length === 0) {
        this.$message.error('统计依据必须存在统计列!')
      } else {
        // 保存筛选条件
        if (this.seniorFilter && this.seniorFilter.filters) {
          this.reportService.report.filters = this.reportService.report.filters.filter(m => m.filterType !== 'senior')
          this.seniorFilter.filters.forEach(m => {
            this.reportService.createOrUpdate(m)
          })
        }
        // 特殊处理默认筛选和高级筛选。高级筛选为更新筛选项
        if (this.reportService.report.filterExpression !== expression ||
        this.reportService.report.advancedFilter !== advancedFilter ||
        this.reportService.report.groupFilterExpressionStr !== this.groupFilterExpressionStr) {
          this.reportComment.changeFilter = true
        }
        if (JSON.stringify(this.reportService.report.groupBies) !== JSON.stringify(groupBies) ||
        JSON.stringify(this.reportService.report.orderBies) !== JSON.stringify(orderBies) ||
        this.reportService.report.groupByEnable !== groupByEnable ||
        this.reportService.report.securityEnable !== securityEnable ||
         this.reportService.report.conditionsRequired !== conditionsRequired ||
        this.reportService.report.appSwitch !== this.appSwitch ||
        JSON.stringify(this.reportService.report.appModel) !== JSON.stringify(this.appModel) ||
         this.reportService.report.batchHandle !== this.batchHandle ||
          this.reportService.report.pageNumber !== this.pageNumber || JSON.stringify(groupReportData) !== JSON.stringify(this.reportService.report.groupReportData) ||
          JSON.stringify(this.reportService.report.mergeSame) !== JSON.stringify(this.mergeSame)) {
          this.reportComment.changeAttr = true
        }
        this.reportService.report.groupBies = groupBies
        this.reportService.report.orderBies = orderBies
        this.reportService.report.groupByEnable = groupByEnable
        this.reportService.report.securityEnable = securityEnable
        this.reportService.report.conditionsRequired = conditionsRequired
        this.reportService.report.systemFilterSwitch = this.systemFilterSwitch
        this.reportService.report.appSwitch = this.appSwitch
        this.reportService.report.appModel = this.appModel
        this.reportService.report.appModel.moduleName = this.reportService.report.appModel.moduleName || this.reportService.report.name
        this.reportService.report.batchHandle = this.batchHandle
        this.reportService.report.pageNumber = this.pageNumber
        this.reportService.report.operationPosition = this.operationPosition
        this.reportService.report.openStartLoadData = this.openStartLoadData
        this.reportService.report.bgColor = this.bgColor
        this.reportService.report.advancedFilter = advancedFilter
        this.reportService.report.filterExpression = expression
        this.reportService.report.groupReportData = groupReportData
        this.reportService.report.mergeSame = this.mergeSame
        this.reportService.report.columnEdit = this.columnEdit
        if (!this.columnEdit) {
          this.editColumns = []
          this.editColumnForm = ''
        }
        this.reportService.report.editColumns = this.editColumns
        this.reportService.report.editColumnForm = this.editColumnForm
        this.reportService.report.groupFilterExpressionStr = this.groupFilterExpressionStr
        this.closeAttr()
      }
    },
    closeAttr () {
      this.$emit('openDataSource')
    },
    scrollDown () {
      this.$nextTick(() => {
        let scroll = this.$refs.panelBasic
        if (scroll.scrollHeight > scroll.clientHeight) {
          scroll.scrollTop = scroll.scrollHeight - scroll.clientHeight
        }
      })
    }
  }
}
</script>

<style lang="scss">
.component-button {
  height: 100%;
  .panel-basic {
    height: calc(100% - 35px);
    overflow-y: auto;
    max-height: 580px;
    .el-collapse-item__header{
      color: #409eff;
    }
    .el-collapse {
      height: 100%;
      >div {
        border-bottom: 1px solid #c2c3c4;
        .el-collapse-item__wrap {
          border-bottom: none;
        }
        &.filter-senior {
          border: none;
        }
      }
      .form {
        margin-top: 2px;
        margin-bottom: 2px;
        padding-left: 25px;
        padding-right: 16px;
        .type-content {
          padding-bottom: 12px;
          .type-filter {
            padding-bottom: 5px;
            .type-icon {
              text-align: right;
              cursor: pointer;
              .left-icon {
                margin-right: 14px;
              }
              .right-icon>img{
                padding-bottom: 3px;
              }
            }
          }
          .input-type {
            .el-input__suffix {
              i {
                line-height: 28px;
              }
            }
          }
        }
      }
    }
    .panel-title {
      .el-collapse-item__header {
        height: 40px;
        line-height: 40px;
      }
      i.el-icon-arrow-right {
        line-height: 40px;
      }
    }

    .el-collapse-item__wrap {

    }

    .el-collapse-item__header {
      padding-left: 25px;
      padding-right: 16px;

      &:hover {
        background-color: #ecf5ff;
      }
      &:focus {
        outline: 0;
        color: #409EFF;
      }
    }
  }
  .panel-basic-btns {
    height: 10%;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    background: #fff;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    button{
      width: 72px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/basic-panel.vue